var script = {
  name: 'PendoThemeSwatch',
  props: {
    swatch: {
      type: Array,
      required: true
    },
    condensed: {
      default: false,
      type: Boolean
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-theme-swatch.vue2.js.map
